// RK Mega-Menu Hover Fix v4
// Updated: removed dropdown arrow, aligned with rk-mega-open class system
// Works with both old mega-menu-container and new rk-mega-menu HTML structures
(function () {
  'use strict';
  function initRKMegaMenu() {
    var items = document.querySelectorAll('.menu-item-has-megamenu');
    if (!items.length) return;
    // ── 1. Inject minimal CSS (no arrow, no rk-open conflicts) ─────────────────
    if (!document.getElementById('rk-mega-fix-v4')) {
      var style = document.createElement('style');
      style.id = 'rk-mega-fix-v4';
      style.textContent = [
        /* ---- Hide ALL arrow spans (rk-nav-arrow) ---- */
        '.rk-nav-arrow { display: none !important; width: 0 !important; height: 0 !important; }',
        /* ---- Kill ALL CSS :hover triggers so only JS controls visibility ---- */
        '.menu-item-has-megamenu:hover .rk-mega-menu { }',
        '.menu-item-has-megamenu:hover .sub-menu.mega-menu-container { display: none !important; }',
        '.menu-item-has-megamenu:hover > .sub-menu { display: none !important; }',
        '.thb-full-menu li.menu-item-has-children.menu-item-has-megamenu:hover > .sub-menu { display: none !important; }',
        /* ---- Default hidden state for sub-menus (not rk-mega-menu which uses visibility/opacity) ---- */
        '.menu-item-has-megamenu > .sub-menu { display: none; pointer-events: none; }',
        /* ---- Remove old misplaced arrow pseudo-elements ---- */
        '.thb-full-menu li.menu-item-has-children > a::after { display: none !important; }',
        /* ---- Bridge gap between nav link and dropdown ---- */
        '.menu-item-has-megamenu.rk-mega-open > a::before { content: ""; position: absolute; bottom: -10px; left: 0; right: 0; height: 10px; z-index: 9998; }',
        '.menu-item-has-megamenu > a { position: relative; }',
      ].join('\n');
      document.head.appendChild(style);
    }
    // ── 2. Remove any existing rk-nav-arrow spans ──────────────────────────────
    document.querySelectorAll('.rk-nav-arrow').forEach(function(el) {
      el.parentNode.removeChild(el);
    });
    // ── 3. JS hover with delay (using rk-mega-open class) ─────────────────────
    items.forEach(function (item) {
      if (item.dataset.rkV4) return; // already initialized
      item.dataset.rkV4 = '1';
      var timer = null;
      function openMenu() {
        clearTimeout(timer);
        // Close all others
        items.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('rk-mega-open');
            other.classList.remove('rk-open');
          }
        });
        item.classList.add('rk-mega-open');
        item.classList.add('rk-open');
      }
      function scheduleClose() {
        clearTimeout(timer);
        timer = setTimeout(function () {
          item.classList.remove('rk-mega-open');
          item.classList.remove('rk-open');
        }, 120);
      }
      function cancelClose() {
        clearTimeout(timer);
      }
      item.addEventListener('mouseenter', openMenu);
      item.addEventListener('mouseleave', scheduleClose);
      // Keep open when mouse is inside the dropdown panel
      var dropdown = item.querySelector('.rk-mega-menu') || item.querySelector('.sub-menu');
      if (dropdown) {
        dropdown.addEventListener('mouseenter', cancelClose);
        dropdown.addEventListener('mouseleave', scheduleClose);
      }
      // Keyboard: Escape closes
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          item.classList.remove('rk-mega-open');
          item.classList.remove('rk-open');
        }
      });
    });
    // ── 4. Close on outside click ──────────────────────────────────────────────
    if (!document._rkOutsideClick) {
      document._rkOutsideClick = true;
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.menu-item-has-megamenu')) {
          items.forEach(function (i) {
            i.classList.remove('rk-mega-open');
            i.classList.remove('rk-open');
          });
        }
      });
    }
  }
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRKMegaMenu);
  } else {
    initRKMegaMenu();
  }
  // Retry after 600ms for Shopify deferred rendering
  setTimeout(initRKMegaMenu, 600);
})();
